import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import { updateMobileNumber } from './editProfileSlice';

const initialState = {
  panNumber: '',
  mobileNumber: '',
};

export const nachCancellationSlice = createSlice({
  name: 'nachCancellation',
  initialState,
  reducers: {
    updatePanNumber: (state, action) => {
      state.panNumber = action.payload;
    },
    updateMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
  },
});

export function useNachCancellationStore() {
  const panNumber = useSelector((state) => state.nachCancellation.panNumber);
  const mobileNumber = useSelector(
    (state) => state.nachCancellation.mobileNumber
  );
  const dispatch = useDispatch();
  return {
    mobileNumber,
    panNumber,
    //reducers
    updateMobileNumber: (mobileNumber) =>
      dispatch(updateMobileNumber(mobileNumber)),
    updatePanNumber: (panNumber) => dispatch(updatePanNumber(panNumber)),
  };
}

export const { updatePanNumber } = nachCancellationSlice.actions;

export default nachCancellationSlice.reducer;
